import {
  createEntityMediaService,
  type EntityMedia,
  type EntityMediaSummary,
  type EntityMediaUploadResult,
} from '@/shared/media'

const batchMediaService = createEntityMediaService({
  scopeValue: 'asset_holding',
  typeValues: ['image', 'video'],
  serviceLabel: 'entity attachment',
  summaryPreviewLimit: 1,
})

export type BatchMedia = EntityMedia & {
  holding_id?: string
}
export type BatchMediaUploadResult = EntityMediaUploadResult
export type BatchMediaPreview = EntityMediaSummary['previews'][number]
export type BatchMediaSummary = EntityMediaSummary

export async function uploadBatchMedia(
  unitId: string,
  holdingId: string,
  file: File,
  mediaName?: string,
): Promise<BatchMediaUploadResult> {
  return batchMediaService.uploadEntityMedia({
    unitId,
    entityId: holdingId,
    file,
    mediaName,
  })
}

export async function getBatchMedia(holdingId: string): Promise<BatchMedia[]> {
  return batchMediaService.getEntityMedia(holdingId)
}

export async function getBatchMediaSummaries(holdingIds: string[]): Promise<Record<string, BatchMediaSummary>> {
  return batchMediaService.getEntityMediaSummaries(holdingIds)
}

export async function getBatchMediaUrl(mediaPath: string): Promise<string> {
  return batchMediaService.getEntityMediaUrl(mediaPath)
}

export async function updateBatchMediaName(mediaId: string, mediaName: string): Promise<BatchMedia> {
  return batchMediaService.updateEntityMediaName(mediaId, mediaName)
}

export async function setBatchMediaFavorite(holdingId: string, mediaId: string): Promise<BatchMedia[]> {
  return batchMediaService.setEntityMediaFavorite(holdingId, mediaId)
}

export async function deleteBatchMedia(mediaId: string, mediaPath: string): Promise<void> {
  return batchMediaService.deleteEntityMedia(mediaId, mediaPath)
}

export { batchMediaService }
